var map = {
	"./logo_esn_invert_de.svg": 25680,
	"./logo_esn_invert_en.svg": 52068,
	"./logo_esn_invert_fr.svg": 6933,
	"./logo_esn_invert_nl.svg": 9995
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81625;